import { render, staticRenderFns } from "./UploadBlock.vue?vue&type=template&id=26e2222c&"
import script from "./UploadBlock.vue?vue&type=script&lang=js&"
export * from "./UploadBlock.vue?vue&type=script&lang=js&"
import style0 from "./UploadBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports